import { type OpenApiSchemaImportTypeMappingSlug } from '#shared/api/schema';
import { isNotNullOrUndefined } from '#shared/lib/array';
import { type TagWithScope } from '#shared/lib/integrations';

export function getTagKeysByScope(tags: TagWithScope[], scope: 'characteristic'): string[];
export function getTagKeysByScope(tags: TagWithScope[], scope: 'property'): OpenApiSchemaImportTypeMappingSlug[];

export function getTagKeysByScope(tags: TagWithScope[], scope: TagWithScope['scopeArea']) {
    return tags
        .filter((tag) => tag.scopeArea === scope)
        .map((tag) => String(tag.key))
        .filter(isNotNullOrUndefined);
}
